module.exports = __webpack_public_path__ + "img/logo-secondary.30b7bd3b.svg";